import * as React from 'react';
import { ReportsConfigRootFolder } from './ReportsConfigRootFolder';
import { ReportsAdministrationForm } from './ReportsAdministrationForm';
import Alert, { AlertCategoryEnum } from '../../misc/components/Alert';
import { ReportAdministrationView } from '../ReportsState';
import * as AdministrationActions from './AdministrationActions';
import { MainState } from '../../Core/reducers';
import { connect } from 'react-redux';
import { Dispatch } from "redux";
import { Folder } from '../../misc/api/ReportsApiTypes';
import Modal from '../../misc/components/modal';
import { ToggleReportServerConnectionVisibilityAction } from './AdministrationActions';
import Loading from '../../misc/components/loading';
import { SSRSCredential } from '../../misc/api/apiTypes';
import { Form } from 'informedv4';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { useWebPortalLegacyClient } from '../../misc/api/WebPortalTokenClient';

interface ReportServerConnectionModalProps {
    isVisible: boolean;
    isConnected?: boolean;
    currentAdministrationView: ReportAdministrationView;
    defaultCredentials: SSRSCredential;
    availableFolders: Array<Folder>;
    selectedRootFolderId: string;
    dispatch?: Dispatch<MainState>;
}

export const ReportServerConnectionModal = (props: ReportServerConnectionModalProps) => {
    const { study } = useCurrentStudyConfigurationContext();
    const legacyClient = useWebPortalLegacyClient();

    const renderContent = () => {
        if (props.currentAdministrationView === ReportAdministrationView.Credentials) {
            return (
                <Form validateOn="submit">
                    <ReportsAdministrationForm
                        defaultServerURL={props.defaultCredentials ? props.defaultCredentials.ServerURL : null}
                        defaultUsername={props.defaultCredentials ? props.defaultCredentials.Username : null}
                        handleSubmit={(form) => props.dispatch(AdministrationActions.UpdateReportServerCredentialsAsyncAction.create(legacyClient, form))}
                        isConnected={props.isConnected}
                    />
                </Form>
            );
        } else if (props.currentAdministrationView === ReportAdministrationView.Loading) {
            return (<Loading />);
        } else {
            props.dispatch(ToggleReportServerConnectionVisibilityAction.create());
        }
    }

    if (props.isVisible) {
        return (
            <Modal show={true} header="Report Server Connection" closeModalHandler={() => props.dispatch(ToggleReportServerConnectionVisibilityAction.create())}>
                <div className="modal-body">
                    <Alert show={true} category={props.isConnected ? AlertCategoryEnum.Success : AlertCategoryEnum.Danger}>{props.isConnected ? 'Report Server Connected' : 'Cannot connect to Report Server'}</Alert>
                    {renderContent()}
                </div>
            </Modal>
        );
    } else {
        return null;
    }
}

function mapStateToProps(state: MainState): ReportServerConnectionModalProps {
    return {
        isVisible: state.reports.administration.isConnectionModalVisible,
        isConnected: state.reports.administration.isConnectedToReportServer,
        currentAdministrationView: state.reports.administration.currentView,
        defaultCredentials: state.reports.administration.credentials,
        selectedRootFolderId: state.reports.administration.selectedStudyRootFolder,
        availableFolders: state.reports.administration.availableFolders ? state.reports.administration.availableFolders.Data : null,
    }
}

export default connect<ReportServerConnectionModalProps, any>(mapStateToProps)(ReportServerConnectionModal)
